import { render, staticRenderFns } from "./Notams.vue?vue&type=template&id=138d164e&scoped=true&"
import script from "./Notams.vue?vue&type=script&lang=js&"
export * from "./Notams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138d164e",
  null
  
)

export default component.exports